import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';

const ContextMenu = (props) => {
    return (
        <Menu open={props.position.top !== null} onClose={props.onClose}
              anchorReference="anchorPosition"
              anchorPosition={
                  (props.position.left !== null && props.position.top !== null)
                      ? {...props.position}
                      : undefined
              }
        >
            {props.children}
        </Menu>
    );
};

ContextMenu.propTypes = {
    position: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ContextMenu;
